"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterWithRules;
function filterWithRulesLoop(rules, obj) {
  var basePropPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return Object.keys(rules).reduce(function (acc, key) {
    var propPath = basePropPath !== '' ? "".concat(basePropPath, ".").concat(key) : key;
    if (typeof rules[key] === 'object') {
      if (typeof obj[key] !== 'object') {
        throw new Error("Expected prop at path \"".concat(propPath, "\" to be an object"));
      }
      // eslint-disable-line no-param-reassign,max-len
      acc[key] = filterWithRulesLoop(rules[key], obj[key], propPath);
    } else if (rules[key]) {
      if (typeof obj[key] === 'undefined') {
        throw new Error("Filter set an \"allow\" on path \"".concat(propPath, "\", however, this path was not \nfound on the source object."));
      }
      acc[key] = obj[key]; // eslint-disable-line no-param-reassign
    }
    return acc;
  }, {});
}

/**
 * Applies a rules object to filter a given object's structure.
 *
 * The rules object should match the shape of the source object and should
 * have a truthy/falsey value indicating if a property should be included/
 * excluded.  If the filters do not contain a property that exists on the
 * source object then the respective property will be excluded.
 *
 * @param  {Object} rules : The filter rules.
 * @param  {Object} obj   : The object to filter.
 *
 * @return {Object}
 *   The filtered object.
 *
 * @example
 *   filter(
 *     // rules
 *     {
 *       foo: { bar: true },
 *       poop: true
 *     },
 *     // source
 *     {
 *       foo: { bar: 'bar', qux: 'qux' },
 *       bob: 'bob',
 *       poop: { plop: 'splash' }
 *     },
 *   )
 */
function filterWithRules(rules, obj) {
  return filterWithRulesLoop(rules, obj);
}